'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _factories = require('function-tree/factories');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _factories.debounce;
  }
});
//# sourceMappingURL=debounce.js.map


//////////////////
// WEBPACK FOOTER
// ./~/cerebral/lib/operators/debounce.js
// module id = 262
// module chunks = 0